import {ChevronLeft, ChevronRight} from '@material-ui/icons';
import {CalendarMonth, DateRange} from '@mui/icons-material';
import {Modal} from '@mui/material';
import {DateCalendar, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {useEffect, useState} from 'react';

export default function LaporanKerjaDate({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setOpen,
  setView,
}) {
  const dateName = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  const [count, setCount] = useState(0);
  const [selectedPicker, setSelectedPicker] = useState('start');
  const formatDate = (date) => {
    return (
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    );
  };
  const formatDateRangeSameYear = (startDate, endDate) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start.getFullYear() === end.getFullYear()) {
      return `${start.getDate()} ${
        months[start.getMonth()]
      } - ${end.getDate()} ${months[end.getMonth()]} ${end.getFullYear()}`;
    } else {
      return `${start.getDate()} ${
        months[start.getMonth()]
      } ${start.getFullYear()} - ${end.getDate()} ${
        months[end.getMonth()]
      } ${end.getFullYear()}`;
    }
  };
  const calcSevenDateByIndex = (index) => {
    const today = new Date();
    const firstSunday = new Date(
      today.setDate(today.getDate() - today.getDay() + 7 * count)
    );
    const firstDay = new Date(
      firstSunday.setDate(firstSunday.getDate() + index)
    );
    return firstDay;
  };
  const styleToday = (date) => {
    if (
      formatDate(date) === formatDate(startDate) ||
      formatDate(date) === formatDate(endDate)
    ) {
      // if (
      //   selectedPicker === 'start' &&
      //   formatDate(date) === formatDate(startDate)
      // ) {
      //   return 'active';
      // } else if (
      //   selectedPicker === 'end' &&
      //   formatDate(date) === formatDate(endDate)
      // ) {
      //   return 'active';
      // }
      return 'selected';
    } else if (date > new Date(startDate) && date < new Date(endDate)) {
      return 'range';
    }
    return '';
  };

  const onClickDate = (date) => {
    setStartDate(date);
    setEndDate(date);
  };
  return (
    <>
      <div className='lk_date_header'>
        <div>{formatDateRangeSameYear(startDate, endDate)}</div>
        <CalendarMonth
          onClick={() => {
            setOpen(true);
            setView('year');
          }}
          className='calendar_icon'
        />
      </div>
      <div className='lk_date_ctr'>
        <ChevronLeft className='lk_arrow' onClick={() => setCount(count - 1)} />
        <div className='lk_date_wrapper'>
          {dateName.map((item, index) => (
            <div key={'lk_date_item_' + index} className='lk_date_item date'>
              <div className='date_name'>{item}</div>
              <div
                className={`date_num ${styleToday(
                  calcSevenDateByIndex(index)
                )}`}
                onClick={() => onClickDate(calcSevenDateByIndex(index))}
              >
                {calcSevenDateByIndex(index).getDate()}
              </div>
            </div>
          ))}
        </div>
        <ChevronRight
          className='lk_arrow'
          onClick={() => setCount(count + 1)}
        />
      </div>
    </>
  );
}
